/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useId, useState } from 'react'
import Highcharts from 'highcharts'
import HC_data from 'highcharts/modules/data'
import { BarChartData } from '../../types/StatTypes'
import ChartSkeleton from '../skeleton/ChartSkeleton'
import BaseChart from './BaseChart'

interface IBarChartProps {
  chartData: BarChartData
}

const BarChart = (props: IBarChartProps) => {
  const { chartData } = props
  const [isLoading, setIsLoading] = useState(true)
  const chartId = useId()

  useEffect(() => {
    if (chartData) {
      setIsLoading(true)
      const timer = setTimeout(() => setIsLoading(false), 400)
      return () => clearTimeout(timer)
    }
  }, [chartData])

  useEffect(() => {
    if (typeof HC_data === 'function') {
      HC_data(Highcharts)
    }
  }, [])

  const options: any = {
    chart: {
      marginRight: 25, // Prevents text in last tick from cutting off
      type: 'bar',
      backgroundColor: 'transparent',
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: chartData.categories,
      gridLineWidth: 1,
      lineWidth: 0,
      labels: {
        style: {
          color: chartData.textColor,
        },
      },
      gridLineColor: chartData.gridColor || '#E0E0E0',
    },
    yAxis: {
      max: 100,
      title: '',
      labels: {
        format: '{value}%',
        style: {
          color: chartData.textColor,
        },
      },
      gridLineColor: chartData.gridColor || '#E0E0E0',
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      shared: true,
      crosshairs: true,
      pointFormatter: function (this: Highcharts.Point): string {
        const rawValue = (this as any).raw
        return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${rawValue} (${this.y}%)</b><br/>`
      },
    },
    series: chartData.series,
    credits: {
      enabled: false,
    },
  }

  return <>{isLoading ? <ChartSkeleton fullWidth={true} /> : <BaseChart options={options} id={chartId} />}</>
}

export default BarChart
